<template xmlns:slot="http://www.w3.org/1999/html">
  <div>
    <div
        v-if="errors.length > 0"
        class="errors">
      <div
          v-for="error in errors"
          class="error-msg">
        <p>{{ error }}</p>
      </div>
    </div>
  <div>
    <client-search-dropdown ref="selector" v-if="clients" v-model:client="selectedClient" @blur="v$.selectedClient.$touch()" :clients="clients" :search-function="clientSearch" />
    <div class="error-msg mt-1 text-red-500" v-if="v$.selectedClient.$error">Must select a Client</div>
    <div class="sm:col-span-6 mt-5">
      <div class="mt-1">
        <label for="tsv" class="block text-sm font-medium text-gray-700">
          Paste Data
        </label>
        <textarea v-model="templateText" @blur="v$.templateText.$touch()" id="tsv" name="tsv" rows="30" class="shadow-sm p-3 focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
        <div class="error-msg mt-1 text-red-500" v-if="v$.templateText.$error">Must provide TSV</div>
      </div>
    </div>
  </div>
  <div class="mt-5">
    <button @click.prevent="handleSubmission" class="py-2 px-4 bg-brand-primary text-white">Submit</button>
  </div>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" static class="fixed z-10 inset-0 overflow-y-auto" @close="open = false" :open="open">
      <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
            <div>
              <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                <CheckIcon class="h-6 w-6 text-green-600" aria-hidden="true" />
              </div>
              <div class="mt-3 text-center sm:mt-5">
                <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                  Payment successful
                </DialogTitle>
                <div class="mt-2">
                  <p class="text-sm text-gray-500">
                    Lorem ipsum, dolor sit amet consectetur adipisicing elit. Eius aliquam laudantium explicabo pariatur iste dolorem animi vitae error totam. At sapiente aliquam accusamus facere veritatis.
                  </p>
                </div>
              </div>
            </div>
            <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
              <button type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:col-start-2 sm:text-sm" @click="open = false">
                Deactivate
              </button>
              <button type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:col-start-1 sm:text-sm" @click="open = false" ref="cancelButtonRef">
                Cancel
              </button>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
    <gravy-modal v-on:modal:cancel="sentModalIsOpen = false" :open="sentModalIsOpen">
      <template v-slot:title>
        Email Queue Results
      </template>
      <template v-slot:content>
        <div class="mt-2">
          <div>
            <strong>Success Count: </strong>
            <span>{{ sentSuccessCount}}</span>
          </div>
        </div>
        <div class="mt-2">
          <div>
            <strong>Failure Count: </strong>
            <span>{{ sentFailureCount}}</span>
          </div>
        </div>

      </template>
      <template v-slot:actionButton>
        <primary-button type="button" text="Close" @click="sentModalIsOpen = false" />
      </template>
    </gravy-modal>
    <gravy-modal width="max-w-5xl min-w-modal" v-on:modal:cancel="approveModalIsOpen = false" :open="approveModalIsOpen">
      <template v-slot:title>This is what your email will look like</template>
      <template  v-slot:content>
        <div>
          <small>
            NOTE: This is only an example from one email.
          </small>
        </div>
        <div>
          Press Approve to Send, or Cancel to not send these emails.
        </div>
        <div class="mt-2">
          <div>
            <strong>Email Count: </strong>
            <span>{{ approveCount}}</span>
          </div>
        </div>
        <div class="grid grid-cols-2 gap-4">
          <div class="text-left">
            <div class="mt-2">
              <div>
                <strong>Emailed To: </strong>
                <span>{{ approveResponse.exampleEmailTo}}</span>
              </div>
            </div>
            <div class="mt-2">
              <div>
                <strong>Email From: </strong>
                <span>{{ approveResponse.exampleEmailFrom}}</span>
              </div>
            </div>
            <div class="mt-2">
              <div>
                <strong>Email Subject: </strong>
                <span>{{ approveResponse.exampleSubject}}</span>
              </div>
            </div>
          </div>
          <div class="text-left">
            <div class="mt-2">
              <div>
                <strong>BCC: </strong>
                <span>{{ approveResponse.exampleEmailBCC}}</span>
              </div>
            </div>
            <div class="mt-2">
              <div>
                <strong>Email Reply To: </strong>
                <span>{{ approveResponse.exampleEmailReplyTo}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <div class="text-left">
            <div class="mt-1">
              <email-preview :preview-content="approveResponse.exampleBody" />
            </div>

          </div>
        </div>
      </template>

      <template v-slot:cancelButton>
        <neutral-button type="button" text="Cancel" @click="approveModalIsOpen = false" />
      </template>
      <template v-slot:actionButton>
        <primary-button type="button" text="Send" @click="handleSendEmail" />
      </template>
    </gravy-modal>

  </div>
</template>

<script>
import {ref, computed} from 'vue'
import GravyImageDropdownMenu from "@/components/GravyImageDropdownMenu";
import GravyDropdownMenu from "@/components/GravyDropdownMenu";
import tsvJSON from "@/utils/tsvConverter";
import Mustache from "mustache"
import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { CheckIcon } from '@heroicons/vue/outline'
import ClientSearchDropdown from "@/components/ClientSearchDropdown";
import GeneralModal from "@/components/Functional/Modal/GeneralModal";
import GravyModal from "@/components/Functional/Modal/GravyModal";
import NeutralButton from "@/components/Functional/Buttons/NeutralButton";
import PrimaryButton from "@/components/Functional/Buttons/PrimaryButton";
import gravyAxios from "@/plugins/axios"
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import EmailPreview from "@/components/Functional/EmailPreview/EmailPreview";

export default {
  name: "SendEmail",
  components: {
    EmailPreview,
    PrimaryButton,
    NeutralButton,
    GravyModal,
    GeneralModal,
    ClientSearchDropdown,
    GravyDropdownMenu,
    GravyImageDropdownMenu,
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    CheckIcon
  },
  setup() {
    const clientChildRef = ref(null)
    let dataText = ''
    let parsedTemplate = ''
    let open = false;

    return {
      v$: useVuelidate(),
      clientChildRef,
      dataText,
      parsedTemplate,
      open
    }
  },
  data() {
    return {
      approveModalIsOpen: false,
      templateText: '',
      selectedClient: null,
      approveResponse: null,
      approveCount: null,
      sentResponse: null,
      sentSuccessCount: null,
      sentFailureCount: null,
      sentModalIsOpen: false,
      errors: []
    }
  },
  validations() {
    return {
      templateText: { required },
      selectedClient: { required },
    }
  },
  async mounted() {
    try {
      this.$store.dispatch('getClients')
    }catch (e) {
     this.errors.push(e)
    }
  },
  methods: {
    clientSearch(input) {
      return this.clients[0].name
    },
    async handleSendEmail() {
      this.v$.$validate()
      if (!this.v$.$error) {
        this.approveModalIsOpen = false;
        this.$store.dispatch('showLoadingSpinner')

        try {
          let sendResponse = await gravyAxios.post('/email/approve', {
            approvedData: '',
            clientId: this.$refs.selector.selectedClient.id,
            tsv: this.templateText
          })
          if (sendResponse.status === 201) {
            this.sentResponse = sendResponse.data.templatesSent[0]
            this.sentSuccessCount = sendResponse.data.totalSuccessCount
            this.sentFailureCount = sendResponse.data.totalFailureCount
            this.sentModalIsOpen = true
          }
        } catch (e) {

          this.$store.dispatch('createAlert', {
            type: 'danger',
            message: e
          })
        }
        this.$store.dispatch('hideLoadingSpinner')

      }
    },
    async handleSubmission() {
      this.v$.$validate()
      this.errors = []

      if (!this.v$.$error) {
        this.$store.dispatch('showLoadingSpinner')

        try {
          let approveResponse = await gravyAxios.post('/email/check', {
            approvedData: '',
            clientId: this.$refs.selector.selectedClient.id,
            clientName: this.$refs.selector.selectedClient.name,
            tsv: this.templateText
          })
          if (approveResponse.status === 201) {
            this.approveResponse = approveResponse.data.templatesToSend[0]
            this.approveCount = approveResponse.data.totalCount
            this.approveModalIsOpen = true
          }
        } catch (e) {
          this.errors = e.response.data.errors
          this.$store.dispatch('createAlert', {
            type: 'danger',
            message: e
          })
        }
        this.$store.dispatch('hideLoadingSpinner')

      }
    }
  },
  computed: {
    clients() {
      return this.$store.getters.getClients
    },
    products() {
      return this.$store.getters.getProducts
    },
    templates() {
      return this.$store.getters.getTemplates
    },
    prettyDisplay() {
      return this.dataText

      // return tsvJSON(this.dataText)
      // return JSON.stringify(JSON.parse(formatted), null, 2);
    },
    parsedData() {
      return this.parsedTemplate
    }
  },
  filters: {
    pretty: function(value) {
      let formatted = tsvJSON(value)
      return JSON.stringify(JSON.parse(formatted), null, 2);
    }
  }
}
</script>

<style scoped>

</style>
